import intl from 'react-intl-universal';
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ErrorJudgeType } from '@/type/components';
import { useModel } from '@umijs/max';
import { Col, Radio, Row, Select } from 'antd';
import { useEffect } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';

type ErrorJudgeProps = {
    value?: ErrorJudgeType;
    onChange?: (value: ErrorJudgeType) => void;
    disable?: boolean;
    readonly?: boolean;
};

const ErrorJudge: React.FC<ErrorJudgeProps> = ({
    value,
    onChange,
    readonly,
}) => {
    const { workOrderEnums: enums } = useModel('global');
    const [errorOrder, setIsError] = useState(value?.errorOrder || 2);
    const [reason, setReason] = useState(value?.errorOrderReason);

    const result: ErrorJudgeType = useMemo(() => {
        if (errorOrder) {
            return {
                errorOrder,
                errorOrderReason: reason,
            };
        } else {
            return {
                errorOrder,
            };
        }
    }, [errorOrder, reason]);

    useEffect(() => {
        onChange && onChange(result);
    }, [result]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Row
                gutter={10}
                align="middle"
            >
                <Col>{intl.get('是否错单:')}</Col>
                <Col>
                    <Radio.Group
                        onChange={({ target: { value } }) => setIsError(value)}
                        value={errorOrder}
                        disabled={readonly}
                    >
                        <Radio value={1}>{intl.get('是')}</Radio>
                        <Radio value={2}>{intl.get('否')}</Radio>
                    </Radio.Group>
                </Col>
            </Row>

            {errorOrder === 1 ? (
                <Row
                    gutter={10}
                    align="middle"
                >
                    <Col>{intl.get('错单原因:')}</Col>
                    <Col>
                        <Select
                            style={{ width: 150 }}
                            showSearch
                            value={reason}
                            onChange={setReason}
                            options={enums.errorOrderReasonEnum}
                            disabled={readonly}
                            fieldNames={{
                                label: 'selectLabel',
                                value: 'selectValue',
                            }}
                        />
                    </Col>
                </Row>
            ) : null}
        </div>
    );
};

export default ErrorJudge;
